const utcPinnedTime = Date.UTC(4500, 8, 1);

// For sending out the service request, we must use the UTC time when marking the conversation as pinned.
// Drop the 'Z' at the end of the timestamp
const utcPinnedTimeStamp = new Date(utcPinnedTime).toISOString();
const utcPinnedEwsTimeStamp = utcPinnedTimeStamp.slice(0, -1);

export const getIsPinnedTimestamp = (renewTimestamp: string): boolean => {
    const renewDate = new Date(renewTimestamp);
    return renewDate.getTime() === utcPinnedTime;
};

export { utcPinnedTimeStamp, utcPinnedEwsTimeStamp };
